var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("terminal-bookings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("process-terminal-transactions") },
                    model: {
                      value: _vm.settings.ProcessTerminalTransactions,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.settings,
                          "ProcessTerminalTransactions",
                          $$v
                        )
                      },
                      expression: "settings.ProcessTerminalTransactions",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "info" }, [
            _vm._v(_vm._s(_vm.$ct("terminal-bookings-info"))),
          ]),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-ledger-account-autocomplete", {
                    attrs: {
                      fancy: "",
                      disabled: !_vm.settings.ProcessTerminalTransactions,
                      label: _vm.$ct("terminal-transfer-ledger-account"),
                    },
                    model: {
                      value: _vm.settings.TerminalTransferLedgerAccountCode,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.settings,
                          "TerminalTransferLedgerAccountCode",
                          $$v
                        )
                      },
                      expression: "settings.TerminalTransferLedgerAccountCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.settings.TerminalBookings, function (booking) {
            return _c(
              "w-row",
              { key: booking.Terminal, staticClass: "terminal-row" },
              [
                _c("w-col", { attrs: { xs: "12", md: "4" } }, [
                  _c("div", { staticClass: "terminal-name" }, [
                    _vm._v(_vm._s(_vm.getTerminalName(booking.Terminal))),
                  ]),
                ]),
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "4" } },
                  [
                    _c("app-select-bank-type", {
                      attrs: {
                        "use-ids": "",
                        "include-empty": "",
                        fancy: "",
                        disabled: !_vm.settings.ProcessTerminalTransactions,
                        label: _vm.$ct("terminal-counter-booking-bank"),
                      },
                      model: {
                        value: booking.BankTypeID,
                        callback: function ($$v) {
                          _vm.$set(booking, "BankTypeID", $$v)
                        },
                        expression: "booking.BankTypeID",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "4" } },
                  [
                    _vm.hasCostBooking(booking.Terminal)
                      ? _c("app-ledger-account-autocomplete", {
                          attrs: {
                            fancy: "",
                            disabled: !_vm.settings.ProcessTerminalTransactions,
                            label: _vm.$ct("terminal-cost-ledger-account"),
                          },
                          model: {
                            value: booking.CostLedgerAccountCode,
                            callback: function ($$v) {
                              _vm.$set(booking, "CostLedgerAccountCode", $$v)
                            },
                            expression: "booking.CostLedgerAccountCode",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.saving, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }